const styles = {
  root: {},

  title: {
    fontFamily: "'Montserrat', sans-serif",
    textAlign: 'center'
  },

  link: {
    fontFamily: "'Montserrat', sans-serif",
    textAlign: 'center',
    cursor: 'pointer',
    color: 'rgba(0,0,0,0.75)'
  },

  moreContainer: {
    display: 'flex',
    flexDirection: 'column'
  },

  button: {
    alignSelf: 'center',
    minWidth: 250
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/containers/more/styles.js